module.exports = __webpack_public_path__ + "img/voc_ic1.5b428ad5.png";